import React from 'react';
import { useHistory } from 'react-router';

import { Container } from 'semantic-ui-react';

import { useBreakpoints } from '$app/common/utils/mediaQueries';
import AdditionalResources from './AdditionalResources';

// Footer Component for the Pages
const Footer = () => {
  const { isSmDown } = useBreakpoints();
  const { location } = useHistory();

  return (
    <>
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
          paddingLeft: isSmDown && location.pathname === '/' ? 20 : 0,
          paddingRight: isSmDown && location.pathname === '/' ? 20 : 0,
        }}
      >
        <Container>
          <AdditionalResources />
        </Container>
      </div>

      <footer
        css={{
          width: '100%',
          background: `url(
            'https://images.snaphunt.com/assets/images/curve-02.svg') no-repeat`,
          backgroundSize: 'auto 100%',
          height: '25vh',
          color: 'white',
        }}
      >
        <div
          css={{
            maxWidth: 1200,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '25vh',
            margin: '0 auto',
            paddingLeft: isSmDown ? 15 : 0,
            paddingRight: isSmDown ? 15 : 0,
          }}
        >
          <div>
            <p
              css={{
                fontSize: 12,
                opacity: 0.4,
                width: isSmDown ? 150 : 'auto',
              }}
            >
              Made in Singapore © 2022 Snaphunt Pte. Ltd. All rights reserved.
            </p>
          </div>
          <div css={{ display: 'flex' }}>
            <p css={{ fontSize: 12, textAlign: 'center', opacity: 0.8 }}>
              Supported by
            </p>
            <img
              src="https://images.snaphunt.com/assets/vectors/icons/logoheader.svg"
              css={{
                width: 80,
                paddingBottom: 12,
                paddingLeft: 5,
              }}
              alt="snaphuntLogo"
            />
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
